import { render, staticRenderFns } from "./PokerTablePlayerInfo.vue?vue&type=template&id=764e58eb"
import script from "./PokerTablePlayerInfo.js?vue&type=script&lang=js&external"
export * from "./PokerTablePlayerInfo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports